// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"EN-z","carouselContainer":"FN-z"};